import React from 'react';
import { motion } from 'framer-motion';
import './Process.css';

const Process = () => {
  const steps = [
    {
      title: 'Strategy & Discovery',
      desc: 'We identify market gaps and define a technical roadmap tailored to your specific business KPIs.'
    },
    {
      title: 'Engineering & Design',
      desc: 'Rapid prototyping followed by rigorous full-stack development using our battle-tested boilerplate.'
    },
    {
      title: 'Security & CI/CD Pipeline',
      desc: 'Integrated security audits and automated deployment pipelines to ensure a resilient, always-on infrastructure.'
    },
    {
      title: 'Validation & Testing',
      desc: 'End-to-end automated testing and user acceptance cycles to ensure a flawless product launch.'
    },
    {
      title: 'Scaling & Support',
      desc: 'Continuous monitoring and iterative improvements to help your product scale as you grow.'
    }
  ];

  return (
    <section className="process" id="process">
      <div className="process-container">
        <motion.div 
          className="process-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">The Engineering Blueprint</h2>
          <p className="section-subtitle">How we transform complex ideas into category-defining software.</p>
        </motion.div>

        <motion.div 
          className="process-timeline"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          {steps.map((step, idx) => (
            <div key={idx} className="timeline-item">
              <div className="timeline-marker">
                <div className="marker-dot"></div>
                {idx !== steps.length - 1 && <div className="marker-line"></div>}
              </div>
              <div className="timeline-content">
                <div className="step-tag">Phase 0{idx + 1}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-desc">{step.desc}</p>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Process;
